import { Component, inject, OnInit } from '@angular/core';
import { InicioService } from '../../services/inicio.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.css'
})
export class MenuComponent implements OnInit{
  public service = inject(InicioService);
  menuList:any[] = []
  userData: any;

  ngOnInit(): void {
    this.service.user$.subscribe(user => {
      this.userData = user;
    });
    this.menuList = this.userData.menu
  }


}
